export const TRAILING_DEFAULT_ACTIVATION_PERCENT = 40;
export const TRAILING_DEFAULT_DISTANCE_PERCENT = 30;
export const TRAILING_NARROW_DISTANCE_PERCENT = 15;
export const TRAILING_MIN_DISTANCE_PERCENT = 1;
export const TRAILING_MAX_DISTANCE_PERCENT = 90;
export const TRAILING_MAX_ACTIVATION_PERCENT = 1000;
export function resolveTrailingSettings(activationPercent, distancePercent) {
    return {
        activationPercent: activationPercent != null && activationPercent >= 0
            ? activationPercent
            : TRAILING_DEFAULT_ACTIVATION_PERCENT,
        distancePercent: distancePercent != null && distancePercent > 0
            ? distancePercent
            : TRAILING_DEFAULT_DISTANCE_PERCENT,
    };
}
export function trailingTakeProfitError(activationPercent, distancePercent) {
    if (activationPercent != null &&
        (!Number.isFinite(activationPercent) ||
            activationPercent < 0 ||
            activationPercent > TRAILING_MAX_ACTIVATION_PERCENT)) {
        return `Start trailing after must be between 0% and ${TRAILING_MAX_ACTIVATION_PERCENT}%.`;
    }
    if (distancePercent != null &&
        (!Number.isFinite(distancePercent) ||
            distancePercent < TRAILING_MIN_DISTANCE_PERCENT ||
            distancePercent > TRAILING_MAX_DISTANCE_PERCENT)) {
        return `Drop from the high must be between ${TRAILING_MIN_DISTANCE_PERCENT}% and ${TRAILING_MAX_DISTANCE_PERCENT}%.`;
    }
    return null;
}
export function trailingStopPrice(entryPrice, bestPrice, positionType, settings) {
    if (!(entryPrice > 0) || !(bestPrice > 0))
        return null;
    const long = positionType === "LONG";
    const favourableMove = long
        ? (bestPrice / entryPrice - 1) * 100
        : (1 - bestPrice / entryPrice) * 100;
    if (favourableMove + 1e-9 < settings.activationPercent)
        return null;
    return long
        ? bestPrice * (1 - settings.distancePercent / 100)
        : bestPrice * (1 + settings.distancePercent / 100);
}
//# sourceMappingURL=trailing-take-profit.js.map